import actions from './actions';

const {
  CREATE_EVENTS_BEGIN,
  CREATE_EVENTS,
  CREATE_EVENTS_ERR,
  CREATE_EVENTS_EMPTY,
  FETCH_ALL_EVENTS_LIST_BEGIN,
  FETCH_ALL_EVENTS_LIST,
  FETCH_ALL_EVENTS_LIST_ERR,
  FETCH_EVENTS_DETAILS_BEGIN,
  FETCH_EVENTS_DETAILS,
  FETCH_EVENTS_DETAILS_ERR,
  UPDATE_EVENTS_DETAILS_BEGIN,
  UPDATE_EVENTS_DETAILS,
  UPDATE_EVENTS_DETAILS_ERR,
  UPDATE_EVENTS_DETAILS_EMPTY,
} = actions;

const initialStateFilter = {
  data: [],
  loading: false,
  error: null,
};
const EventsReducer = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case CREATE_EVENTS_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case CREATE_EVENTS:
      return {
        ...initialStateFilter,
        data,
        loading: false,
      };
    case CREATE_EVENTS_ERR:
      return {
        ...initialStateFilter,
        error: err,
        loading: false,
      };
    case CREATE_EVENTS_EMPTY:
      return {
        ...initialStateFilter,
        loading: false,
      };
    default:
      return state;
  }
};

const EventsListReducer = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case FETCH_ALL_EVENTS_LIST_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case FETCH_ALL_EVENTS_LIST:
      return {
        ...initialStateFilter,
        data,
        loading: false,
      };
    case FETCH_ALL_EVENTS_LIST_ERR:
      return {
        ...initialStateFilter,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

const EventsDetailsReducer = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case FETCH_EVENTS_DETAILS_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case FETCH_EVENTS_DETAILS:
      return {
        ...initialStateFilter,
        data,
        loading: false,
      };
    case FETCH_EVENTS_DETAILS_ERR:
      return {
        ...initialStateFilter,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

const UpdateEventsDetailsReducer = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case UPDATE_EVENTS_DETAILS_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case UPDATE_EVENTS_DETAILS:
      return {
        ...initialStateFilter,
        data,
        loading: false,
      };
    case UPDATE_EVENTS_DETAILS_ERR:
      return {
        ...initialStateFilter,
        error: err,
        loading: false,
      };
    case UPDATE_EVENTS_DETAILS_EMPTY:
      return {
        ...initialStateFilter,
        loading: true,
      };
    default:
      return state;
  }
};
export { EventsReducer, EventsListReducer, EventsDetailsReducer, UpdateEventsDetailsReducer };
